/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const ChevronRightSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path d="m11.288 10-3.394 3.394a.6.6 0 0 0-.177.435.6.6 0 0 0 .177.443q.18.181.439.181.258 0 .44-.18l3.744-3.746A.7.7 0 0 0 12.73 10q0-.15-.048-.28a.7.7 0 0 0-.165-.247L8.772 5.728a.6.6 0 0 0-.435-.177.6.6 0 0 0-.443.177.6.6 0 0 0-.181.439q0 .258.181.439z" />
  </svg>
)
const ForwardRef = forwardRef(ChevronRightSvg)
export default ForwardRef
